// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ib-7";
export var emphasizeQuantity = "_ib-3";
export var flatBottomCorners = "_ib-5";
export var productImage = "_ib-0";
export var quantityContainer = "_ib-2";
export var quantityHeader = "_ib-6";
export var tooltip = "_ib-1";
export var wrapAndEllipsesOverflow = "_ib-4";